import { TechnologyType } from '../../../Types/TechnologyType';
import { ToolsType } from '../../../Types/ToolsType';

export type SchemaType = {
	title: string;
	lines: Array<ToolsType>;
};

export const schema: SchemaType = {
	title: 'Highlighted',
	lines: [
		{
			entry: 'Cloud Platforms (AWS / GCP / Azure)',
			showOn: ['all'],
		},
		{
			entry: 'Distributed Systems',
			showOn: ['all'],
		},
		{
			entry: 'Scalability',
			showOn: ['all'],
		},
		{
			entry: 'Event Driven Architecture',
			showOn: ['all'],
		},
		{
			entry: 'SQL / NoSQL',
			showOn: ['all'],
		},
		{
			entry: 'Leadership',
			showOn: ['all'],
		},
		{
			entry: 'Developer Experience',
			showOn: ['all'],
		},
		{
			entry: 'Strategic Planning',
			showOn: ['all'],
		},
		{
			entry: 'Cross-Functional Collaboration',
			showOn: ['all'],
		},
		{
			entry: 'Redis / Memcached',
			showOn: ['all'],
		},
		{
			entry: 'Apex (Java-Like)',
			showOn: ['all'],
		},
	],
};
